import {
  Competition,
  Fixture,
  FixtureListingPage,
  Link,
  Season,
  Team,
} from '@graphql/index';
import {
  CONTENT_TYPES,
  ContentType,
} from '@core/constants/contentTypes.constants';
import { CleanContentful } from '@stadionhq-v3/clean-contentful';
import { isObject } from './common.typeGuards';
import { Page } from '../content/contentTypes.types';

export const isContentType = <T extends { __typename?: string }>(
  value: unknown,
  contentType: ContentType
): value is T =>
  value !== undefined &&
  isObject(value) &&
  Object.hasOwn(value, '__typename') &&
  value.__typename === contentType;

export const isPage = (value: unknown): value is Page & { slug: string } =>
  isObject(value) &&
  Object.hasOwn(value, '__typename') &&
  Object.hasOwn(value, 'slug') &&
  value.slug !== undefined;

/*
  TAG CONTENT TYPES
*/
export const isLink = (value: unknown): value is CleanContentful<Link> =>
  isContentType<CleanContentful<Link>>(value, CONTENT_TYPES.LINK_TAG) &&
  Object.hasOwn(value, 'title') &&
  Object.hasOwn(value, 'url') &&
  value.url !== undefined &&
  value.url !== '';

/*
  FOOTBALL CONTENT TYPES
*/
export const isFixture = (value: unknown): value is CleanContentful<Fixture> =>
  isContentType<CleanContentful<Fixture>>(value, CONTENT_TYPES.FIXTURE_PAGE);

export const isCompetition = (
  value: unknown
): value is CleanContentful<Competition> =>
  isContentType<CleanContentful<Competition>>(value, CONTENT_TYPES.COMPETITION);

export const isSeason = (value: unknown): value is CleanContentful<Season> =>
  isContentType<CleanContentful<Season>>(value, CONTENT_TYPES.SEASON);

export const isTeam = (value: unknown): value is CleanContentful<Team> =>
  isContentType<CleanContentful<Team>>(value, CONTENT_TYPES.TEAM);

export const isFixtureListingPage = (
  value: unknown
): value is CleanContentful<FixtureListingPage> =>
  isContentType<CleanContentful<FixtureListingPage>>(
    value,
    CONTENT_TYPES.FIXTURE_LISTING_PAGE
  );
